import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import LogoComponent from './community-logo-image-url.component';
import CoverImageComponent from './community-cover-image-url.component';

export default function CommunityBasicInfoComponent({ changeLogoImage, changeCoverImage, onInnerBasicFormChange,
    libraryData, communityStatus, selectedCommunity, CommunityType }: any) {
    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedCommunity?.Name}
                    />

                    <InputContainer
                        label="Community Type"
                        labelField="Text"
                        list={libraryData.result.CommunityType}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'CommunityTypeId',
                            )
                        }}
                        optionName="Choose Community Status"
                        type="select"
                        value={selectedCommunity?.CommunityTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Community Status"
                        labelField="Text"
                        list={libraryData.result.CommunityStatus}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'CommunityStatusId',
                            )
                        }}
                        optionName="Choose Community Status"
                        type="select"
                        value={selectedCommunity?.CommunityStatusId}
                        valueField="Value"
                    />


                    <InputContainer
                        label="Region"
                        name="Region"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Region'

                            )
                        }}
                        type="text"
                        value={selectedCommunity?.Region}
                    />

                    <InputContainer

                        label="Training Available"
                        name="IsTrainingAvailable"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsTrainingAvailable'
                            )
                        }}
                        type="checkbox"
                        value={selectedCommunity?.IsTrainingAvailable}
                    />
                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedCommunity?.Description}
                    />

                </div>
            }
            expandedPanel="userInfo"
            headerTitle="Basic Info"
        />
            <AccordionContainer
                child={
                    <div>
                        <LogoComponent
                            selectedCommunity={selectedCommunity}
                            changeLogoImage={changeLogoImage}
                        />

                    </div>
                }
                expandedPanel="logo"
                headerTitle="Logo Info"
            />

            <AccordionContainer
                child={
                    <div>
                        <CoverImageComponent
                            selectedCommunity={selectedCommunity}
                            changeCoverImage={changeCoverImage}

                        />

                    </div>
                }
                expandedPanel="Cover image"
                headerTitle="Coverimage Info"
            />
        </>
    )
}
